import { ItemDelegate } from '@leverege/molten/imagine'
import EventsEnabledGroupDelegate from './EventsEnabledGroupDelegate'; // eslint-disable-line import/no-cycle
import EventsItemDelegate from './EventsItemDelegate'

export default class EventsEnabledItemDelegate extends ItemDelegate {
  constructor( options ) {
    super( options )

    Object.defineProperties( this, {
      eventsDelegate : {
        get : () => {
          if ( !this.hDelegate ) {
            this.eDelegate = new EventsItemDelegate( options, this )
          }

          return this.eDelegate
        }
      }
    } )
  }

  parent( ) {
    const { parent } = this.relationship
    if ( parent == null ) {
      return null
    }
    // if parent is an item or an alias, use ItemDelegate
    if ( parent.isItem || parent.isAlias ) {
      return new EventsEnabledItemDelegate( { 
        relationship : parent, // .createResolved( this.match ), 
        match : this.match, 
        ...this.options 
      } )
    }
    return new EventsEnabledGroupDelegate( { 
      relationship : parent, // .createResolved( this.match ), 
      match : this.match, 
      ...this.options 
    } )

  }
}
